import { render, staticRenderFns } from "./overlay-image-container.vue?vue&type=template&id=e8c618b4"
import script from "./overlay-image-container.vue?vue&type=script&lang=js"
export * from "./overlay-image-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports